<template>
  <div v-if="!isHidden" :class='enterAddress ? "_flex-column" : "_flex"' :style="{width:'100%'}">
    <ConnectMetamask
      v-if="!elementValues.web3Account"
      :isDisabled="isDisabled || enterAddress"
      @accountSelected="web3AccountSelected"
      @onWalletSignature="onWalletSignature"
      version="success"
    />
    <div v-else class="_flex-justify-between _flex-column" :style="{width:'100%'}">
      <div class="_flex-row _flex-justify-between _mbottom-3">
        <ds ds="explorer-link"
          :network="network"
          type="wallet"
          :address="elementValues.web3Account"
        />
        <ds ds="tag"
          icon="checkmark"
          version="success"
          :label="$t('component.ConnectMetamask.connected')"
          class="_mleft-2"
        />
      </div>
      <div class="_flex-justify-end">
        <ds ds="button"
          :label="$t('component.ConnectMetamask.disconnect')"
          icon="open-to-left"
          isReverse
          @click="onDisconnect"
        />
      </div>
    </div>
    <div v-if="!elementValues.web3Account && !element.connectWalletMandatory && !enterAddress">
      <span class="_mx-3" style="color: var(--grey-900);">{{ $t('shared.or') }}</span>
      <ds ds="button"
        :label="$t('component.ConnectMetamask.enterWallet')"
        @click="enterAddress = true"
        :isDisabled="isDisabled"
      />
    </div>
    <div v-else-if="enterAddress">
      <div class="_flex-row _flex-align-center">
        <div class="_my-3 _mright-2" style="color: var(--grey-900);">{{ $t('shared.or') }}</div>
        <hr style="flex-grow: 1" />
      </div>
      <div class="_p-3" style="background-color: var(--grey-300);">
        <ds ds="icon"
          name="close"
          color="var(--coolGrey-400)"
          size="0.8rem"
          style="position: absolute; right: 4rem; cursor: pointer; z-index: 1;"
          @click="enterAddress = false;"
        />
        <ds ds="input-string"
          :label="element.label"
          :name="element.key"
          :validate="v => this.ds.vEthereumAddress(v) ? this.$t('section.wallet.error.invalidWallet') : undefined"
          :value.sync="elementValues[element.key]"
          :isReadonly="readonly"
          :isDisabled="isDisabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus';
import { evaluateCondition } from '@/utils';
import { disconnect } from '@wagmi/core';

export default {
  components: {
    ConnectMetamask: () => import('@/components/elements/ConnectMetamask.vue')
  },
  props: ['element', 'elementValues', 'readonly', 'fieldsetId', 'sectionId'],
  data: () => ({
    network: process.env.VUE_APP_ETHEREUM_NETWORK,
    fieldsetDisabled: false,
    fieldsetHidden: true,
    enterAddress: false
  }),
  computed: {
    isDisabled () {
      if (this.fieldsetDisabled) return true;
      return evaluateCondition(this.element.disabledWhen, this.elementValues);
    },
    isHidden () {
      if (this.fieldsetHidden) return true;
      return evaluateCondition(this.element.hiddenWhen, this.elementValues);
    },
    isHiddenOrDisabled () {
      return this.isHidden || this.isDisabled;
    }
  },
  methods: {
    async web3AccountSelected (account) {
      this.$set(this.elementValues, this.element.key, account);
      this.$set(this.elementValues, 'web3Account', account);
    },

    async onWalletSignature (walletSignature) {
      this.$set(this.elementValues, 'wallet_signature', walletSignature);
    },

    onDisconnect () {
      this.$set(this.elementValues, this.element.key, null);
      this.$set(this.elementValues, 'web3Account', null);
      this.$set(this.elementValues, 'wallet_signature', null);
      disconnect();
    }
  },
  created () {
    this.$set(this.elementValues, 'web3Provider', 'metamask');
    this.$set(this.elementValues, 'web3InputKey', this.element.key);

    if (this.fieldsetId) {
      eventBus.$on('fieldsetDisabled', ({ fieldsetId, isDisabled }) => {
        if (this.fieldsetId && this.fieldsetId === fieldsetId) {
          this.fieldsetDisabled = isDisabled;
        }
      });
      eventBus.$on('fieldsetHidden', ({ fieldsetId, isHidden }) => {
        if (this.fieldsetId && this.fieldsetId === fieldsetId) {
          this.fieldsetHidden = isHidden;
        }
      });
    }
  },
  watch: {
    isHidden () {
      if (this.isHidden) {
        // emulate old design-system reset on disconnect functionality
        this.elementValues[this.element.key] = null;
      }
    }
  }
};
</script>
